import MdaeTabPanel from "./component";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
import { ITabPanelOptions } from "devextreme-react/tab-panel";
export interface IMdaeTabPanelProps extends ITabPanelOptions {
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaeTabPanel;